module.exports = __webpack_public_path__ + "static/media/challengeAccScreenshot.d828dafd.png";